import React from 'react';
import { Column } from 'new/elements/Table/types';
import { Nexset } from 'new/entities/Nexset';
import { DataSource } from 'new/entities/DataSource';
import { DataSink } from 'new/entities/DataSink';
import { SourceName } from 'new/elements/SourceName';
import { ChipBadge } from 'new/elements/ChipBadge';

const sourceType = {
  DATASET: 'Nexset',
  DATASOURCE: 'Source',
  DATASINK: 'Destination',
  CREDENTIAL: 'Credential',
};

export const columns = [
  {
    name: 'Resource',
    field: 'name',
    renderRow(row) {
      return (
        <SourceName
          type={row.type === 'NEXSET' ? 'nexset' : 'source'}
          name={row.name}
          icon={row.icon}
        />
      );
    },
  },
  {
    name: 'Type',
    field: 'type',
    renderRow(row) {
      return <ChipBadge color="success" label={sourceType[row.type] || 'Source'} />;
    },
  },
  {
    name: 'Owner',
    field: 'owner.name',
  },
  {
    name: 'Shared with',
    field: 'access_label',
  },
] as Column<(Nexset | DataSource | DataSink) & { type: string }>[];
